module.exports = __webpack_public_path__ + "media/assets/community_index/community-hands-7c6f6fe1fd6ea0cbe700db7e75f1d9bd1071d8f24e9c0c31d02c58d91dbf9a57.png";